import type { ReceiptTemplate } from '../schema';

export const shopifyTemplate: ReceiptTemplate = {
  id: 'shopify',
  name: 'Shopify Receipt',
  brand: 'SHOPIFY',
  description: 'Shopify subscription receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'shp-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'SHOPIFY',
        businessNameFontSize: 22,
        addressLines: ['PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'shp-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'invoice', label: 'Invoice:', value: 'SHP-847291034' },
          { id: 'store', label: 'Store:', value: 'acme-store.myshopify.com' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'type', label: 'Billing:', value: 'Monthly' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'shp-plan',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'PLAN: Shopify Basic\nNEXT BILLING: 02/04/2026', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'shp-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'plan', label: 'BASIC PLAN', value: '39.00', isBold: false, isLarge: false },
          { id: 'app', label: 'APPS', value: '15.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '4.46', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '58.46', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'shp-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'shp-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SUCCESSFUL\n\nKEEP BUILDING', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

